import {
  getSchema as getSchema1,
  getValidate as getValidate1,
  uiSchema as uiSchema1,
} from "./schema.requestRentioMoveService.1";
import { IExtraData } from "./schema.requestRentioMoveService.types";
import { getInitialValues } from "./schema.requestRentioMoveService.utils";

export const requestRentioMoveServiceSchema = (extraData: IExtraData) => {
  const initialValues = getInitialValues(extraData);

  return [
    {
      schema: getSchema1(initialValues, extraData),
      uiSchema: uiSchema1(extraData),
      validate: getValidate1(extraData),
    },
  ];
};
